































































































































import { Component, Vue, Watch } from "vue-property-decorator"

import updateTdk, { formatTDK } from "@/utils/tdk"

import downloadDialog, { downloadDialogType } from "@/components/downloadDialog"
import shareDialog from "@/components/shareDialog"
import { timeago } from "@/utils/base"
import { IBreadcrumbItem } from "@/components/breadcrumb/extra"

@Component({
  name: "CommunityArticle",
  components: {
    Content: () => import("@/views/CommunityArticle/components/content.vue"),
    Comment: () => import("./components/comment.vue"),
    GameInfo: () => import("@/views/Article/components/gameInfo.vue"),
    ScanDownload: () => import("@/components/scanDownload/scanDownload.vue"),
    HotContent: () => import("@/views/BbsList/components/HotContent.vue"),
    Breadcrumb: () => import("@/components/breadcrumb/breadcrumb.vue")
  },
  tdk() {
    return this.$store.state.tdk
  },
  beforeRouteUpdate(to, from, next) {
    this.breads = [{ name: "论坛首页", path: "/bbs" }]
    next()
  }
})
export default class CommunityArticle extends Vue {
  breads: IBreadcrumbItem[] = [{ name: "论坛首页", path: "/bbs" }]

  publishTime = ""

  get detail() {
    const TIME = this.$store.state.communityArticle.detail?.time?.create
    this.publishTime = TIME && timeago(TIME * 1000)
    return this.$store.state.communityArticle.detail
  }

  // ssr hook
  serverPrefetch() {
    return this.fetchData()
  }

  beforeMount() {
    if (!this.detail) {
      this.fetchData()
    } else {
      this.formatData()
    }
  }

  fetchData() {
    return new Promise(async (resolve, reject) => {
      try {
        await this.$store.dispatch("communityArticle/FETCH_DETAIL", {
          bbs_id: this.$route.params.bbs_id,
          article_id: this.$route.params.article_id
        })
        this.formatData()

        await this.$store.dispatch("tdk/FETCH_SUB_TDK", {
          type: "bbs",
          _id_or_name: this.$route.params.bbs_id,
          sub_type: "article"
        })

        this.$store.commit(
          "tdk/SET_TDK",
          formatTDK(this.$store.state.tdk, [
            {
              replaceKey: "{游戏名称}",
              replaceVal: this.detail.community?.name || ""
            },
            {
              replaceKey: "{文章标题}",
              replaceVal: this.detail.title
            },
            {
              replaceKey: "{文章正文内容}",
              replaceVal: this.detail.content
                .replace(/<\/?.+?\/?>/g, "")
                .replace(/\n/g, "")
                .replace(/&nbsp/g, "")
                .substr(0, 50)
            },
            {
              replaceKey: "{论坛名称}",
              replaceVal: this.detail.community?.name || ""
            }
          ])
        )

        updateTdk.call(this)

        resolve("")
      } catch (error) {
        reject(error)
        if (!this.$isServer) {
          this.$router.push("/404")
        }
      }
    })
  }

  formatData() {
    this.detail.content = this.detail.content.replace(
      /https:\/\/resource.ghzs.com\/image\/community\/5b694f242924bcf82441b3fc\.png/g,
      "http://static-web.ghzs.com/website-static/images/icon_article.png"
    )
    this.detail.content = this.detail.content.replace(
      /https:\/\/resource.ghzs.com\/image\/community\/575fa87d8ab49e12658b4cds\.png/g,
      "http://static-web.ghzs.com/website-static/images/icon_reply.png"
    )
    this.detail.content = this.detail.content.replace(
      /ghzhushou:\/\/[^("|')]*/g,
      match => {
        return `javascript:void(0); redirect('${match}')`
      }
    )

    this.breads.push({
      name: this.detail.community.name,
      path: `/bbs/${this.detail.community._seq}`
    })
    this.breads.push({
      name: this.detail.title
    })
  }

  destroyed() {
    this.$store.commit("communityArticle/SET_DETAIL", { detail: null })
  }

  handleShare() {
    // shareDialog(
    //   {
    //     rmAfterDestroy: false,
    //     presetData: {}
    //   },
    //   () => {}
    // )
    downloadDialog(
      {
        rmAfterDestroy: false,
        presetData: {
          type: downloadDialogType.BBS
        }
      },
      () => {}
    )
  }

  handleDownload() {
    downloadDialog(
      {
        rmAfterDestroy: false,
        presetData: {
          type: downloadDialogType.BBS
        }
      },
      () => {}
    )
  }

  // 监听路由变化，有变化则重新加载数据
  @Watch("$route")
  routerUpdate(to) {
    this.$store.commit("communityArticle/SET_DETAIL", { detail: null })
    this.fetchData()
  }
}
